import { Box, Flex, ReportPage, Text } from '@/components';
import type React from 'react';
import './IndonesiaProjectLedgerPage.scss';
import { useMinistries } from '@/features/master-table/hooks';
import { getMinistryName } from '@/features/mold/utils';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { AlasanDanTujuanReview } from './AlasanDanTujuanReview';
import { AlurDanaSerupa } from './AlurDanaSerupa';
import { BiayaProgram } from './BiayaProgram';
import { EvaluasiOlehPemerintahDesa } from './EvaluasiOlehPemerintahDesa';
import { IdentitasProgram } from './IdentitasProgram';
import { RealisasiProgram } from './RealisasiProgram';
import { RingkasanProgram } from './RingkasanProgram';

export const IndonesiaProjectLedgerPage: React.FC = () => {
  const { id } = useId();
  const project = useProject(id);
  const ministries = useMinistries();
  const ministryName = getMinistryName({
    targetId: project.data?.ministryId,
    ministries: ministries.data,
  });

  if (!project.data) {
    return null;
  }

  return (
    <ReportPage
      layout={{
        paperSize: 'A4',
        orientation: 'landscape',
      }}
    >
      <Flex vertical gap={16} style={{ width: '100%' }}>
        <Box border="1px solid #000">
          <Flex justify="center" style={{ backgroundColor: '#4e4e4e' }}>
            <Text color="white" text="LEMBAR INFORMASI PROGRAM" variant="h4" />
          </Flex>

          <Flex justify="center">
            <Text text={ministryName} variant="h4" />
          </Flex>
        </Box>

        <IdentitasProgram project={project.data} />
        <AlasanDanTujuanReview project={project.data} />
        <RingkasanProgram project={project.data} />
        <BiayaProgram project={project.data} />
        <RealisasiProgram project={project.data} />
        <EvaluasiOlehPemerintahDesa project={project.data} />
        <AlurDanaSerupa project={project.data} />
      </Flex>
    </ReportPage>
  );
};
